import { AppLink } from '@common/components/Link/AppLink';
import { TruncatedTooltip } from '@common/components/TruncatedTooltip';
import { Clip } from '@features/Clip';
import { useSelectClip } from '@features/Clip/hooks/useSelectedClipSelectors';
import { PlayIcon } from '@radix-ui/react-icons';
import { Badge, Flex, Tooltip } from '@radix-ui/themes';
import { createAssetDetailsPagePath } from '@router';
import { useTranslation } from 'react-i18next';

interface ClipTitleCellProps {
    clip: Clip;
}

export const ClipTitleCell = ({ clip }: ClipTitleCellProps) => {
    const { t } = useTranslation('clipTable');
    const { selectClip } = useSelectClip();

    if (!clip) return null;

    const { id, clipName, hasProxy } = clip;
    const detailPath = createAssetDetailsPagePath(id);

    return (
        <AppLink
            to={detailPath}
            onClick={() => selectClip(id)}
            style={{ display: 'block', width: '100%', textDecoration: 'none' }}
        >
            <Flex align={'center'} gap={'3'} width={'100%'}>
                <Flex align={'center'} gap={'2'} flexShrink={'0'}>
                    {hasProxy && (
                        <Tooltip content={t('tags.proxyAvailable')}>
                            <Badge size='3' variant='soft' radius='full'>
                                <PlayIcon width='14' height='14' />
                            </Badge>
                        </Tooltip>
                    )}
                </Flex>
                <TruncatedTooltip text={clipName}>{clipName}</TruncatedTooltip>
            </Flex>
        </AppLink>
    );
};
